// ============================================
// GWP Cart Script — Haarspullen.nl
// ============================================

if (window.Shopify && window.Shopify.market && window.Shopify.market.handle !== 'nl') {
  throw new Error('GWP: niet-NL markt, script gestopt.');
}

var GWP_CAMPAIGNS = [
  { active: false, tag: 'gwp-wella-eimi',          giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { active: false, tag: 'gwp-kms',                 giftVariantId: '57720099766646', giftHandle: 'therma-shape-quick-blow-dry-75ml' },
  { active: false,  tag: 'gwp-indola-hairpin',      giftVariantId: '57676128715126', giftHandle: 'indola-hairpin' },
  { active: true,  tag: 'gwp-ghd-toolbag',         giftVariantId: '56519708279158', giftHandle: 'ghd-tool-bag' },
  { active: false,  tag: 'gwp-blondme-set',         giftVariantId: '57794776072566', giftHandle: 'schwarzkopf-comb-mirror-set' },
  { active: false,  tag: 'gwp-maniac-topcoat',      giftVariantId: '56590815363446', giftHandle: 'maniac-top-coat-shine' },
  { active: false,  tag: 'gwp-gladskin-lipbalm',    giftVariantId: '57794984542582', giftHandle: 'everyday-lip-balm-spf30' },
{ active: true, tag: 'gwp-hairtowel', giftVariantId: '58324047987062', giftHandle: 'schwarzkopf-hair-towel', minTaggedCount: 2 },
{ active: true, tag: 'gwp-hairtowel-sets', giftVariantId: '58324047987062', giftHandle: 'schwarzkopf-hair-towel', minTaggedCount: 1 },
  { active: false,  tag: 'gwp-sebastian-kaars',     giftVariantId: '57798933315958', giftHandle: 'sebastian-dark-oil-geurkaars' },
  { active: false,  tag: 'gwp-mediceuticals-comb',  giftVariantId: '57728046268790', giftHandle: 'mediceuticals-scalpro-brush-buddy-comb-cleanser' },
  { active: false,  tag: 'gwp-olaplex-set',         giftVariantId: '57863213580662', giftHandle: 'olaplex-no-5-leave-in-travelsize' },
  { active: true, tag: 'gwp-bc-sunprotect',       giftVariantId: '57972553515382', giftHandle: 'bc-sun-beach-towel', minTaggedCount: 2 },
  { active: false, tag: 'gwp-blondme-towel',       giftVariantId: '56414070309238', giftHandle: 'schwarzkopf-hair-towel-wit' },
  { active: false, tag: 'gwp-tee-shampoo', giftVariantId: '57265067426166', giftHandle: 'schwarzkopf-fibre-clinix-hydrate-shampoo' },
{ active: false, tag: 'gwp-janzen-men', giftVariantId: '57838849229174', giftHandle: 'toillettas-mannen-gwp', minTaggedCount: 3 },
{ active: false, tag: 'gwp-janzen-set', giftVariantId: '57838849229174', giftHandle: 'toillettas-mannen-gwp', minTaggedCount: 1 },
{ active: false, tag: 'gwp-beachbag', giftVariantId: '58052123459958', giftHandle: 'schwarzkopf-beach-bag', minTaggedCount: 2 },
{ active: false, tag: 'gwp-beachbag-set', giftVariantId: '58052123459958', giftHandle: 'schwarzkopf-beach-bag', minTaggedCount: 1 },
{ active: true, tag: 'gwp-janzen-mist', giftVariantId: '58111784780150', giftHandle: 'body-mist-c-bergamot-fig-breeze-mini', minTaggedCount: 2 },
  { active: false, tag: 'gwp-attitude-spf', giftVariantId: '56327786955126', giftHandle: 'attitude-lip-balm-plastic-free', minTaggedCount: 2 },
{ active: true, tag: 'gwp-indola-beachbag', giftVariantId: '58095376400758', giftHandle: 'indola-beach-bag' },
{ active: false, tag: 'gwp-heatless-curls', giftVariantId: '57795020554614', giftHandle: 'schwarzkopf-heatless-curling-set', minTaggedCount: 3 },
{ active: false, tag: 'gwp-heatless-curls-sets', giftVariantId: '57795020554614', giftHandle: 'schwarzkopf-heatless-curling-set', minTaggedCount: 1 },
{ active: false, tag: 'gwp-bc-pouch', giftVariantId: '58186312614262', giftHandle: 'schwarzkopf-bc-sun-pouch', minTaggedCount: 2 },
{ active: false, tag: 'gwp-bc-pouch-sets', giftVariantId: '58186312614262', giftHandle: 'schwarzkopf-bc-sun-pouch', minTaggedCount: 1 },
{ active: false, tag: 'gwp-goldwell-bondisands', giftVariantId: '57687202267510', giftHandle: 'bondi-sands-after-sun-aloe-vera-cooling-gel', minTaggedCount: 3 },
{ active: false, tag: 'gwp-goldwell-bondisands-sets', giftVariantId: '57687202267510', giftHandle: 'bondi-sands-after-sun-aloe-vera-cooling-gel', minTaggedCount: 1 },
{ active: false, tag: 'gwp-kis-color', giftVariantId: '56414072602998', giftHandle: 'kis-protecting-shampoo', minTaggedCount: 3 },
{ active: false, tag: 'gwp-curlsmith', giftVariantId: '56327509901686', giftHandle: 'curl-smith-essential-moisture-conditioner', minTaggedCount: 1 },
{ active: true, tag: 'gwp-weleda', giftVariantId: '58148956701046', giftHandle: 'weleda-skin-food-creme', minTaggedCount: 1 },
{ active: true, tag: 'gwp-biosilk', giftVariantId: '56974786068854', giftHandle: 'biosilk-therapy-conditioner', minTaggedCount: 1 },
{ active: false, tag: 'gwp-wellaset', giftVariantId: '56327675216246', giftHandle: 'wella-ultimate-repair-masker', minTaggedCount: 1 },
{ active: false, tag: 'gwp-milkshake', giftVariantId: '56414076240246', giftHandle: 'lipgloss-caramel-brown', minTaggedCount: 1 },
{ active: true, tag: 'gwp-stmnt-grooming', giftVariantId: '57149404348790', giftHandle: 'stmnt-matte-paste', minTaggedCount: 2 },
{ active: true, tag: 'gwp-stmnt-grooming-sets', giftVariantId: '57149404348790', giftHandle: 'stmnt-matte-paste', minTaggedCount: 1 },
{ active: false, tag: 'gwp-wella-fusion', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 3 },
{ active: false, tag: 'gwp-wella-fusion-sets', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 1 },
{ active: false, tag: 'gwp-nioxin-kits', giftVariantId: '58393739067766', giftHandle: 'nioxin-pouch-gift', minTaggedCount: 1 },
{ active: true, tag: 'gwp-blondme-mini', giftVariantId: '58112334659958', giftHandle: 'schwarzkopf-cool-blondes-mask', minTaggedCount: 2 },
{ active: true, tag: 'gwp-blondme-mini-sets', giftVariantId: '58112334659958', giftHandle: 'schwarzkopf-cool-blondes-mask', minTaggedCount: 1 },
{ active: true, tag: 'gwp-indola-curls-sets', giftVariantId: '58411712086390', giftHandle: 'indola-curl-defining-brush', minTaggedCount: 1 },
{ active: false, tag: 'gwp-neofollics', giftVariantId: '58227588825462', giftHandle: 'neofollics-hair-wrap-towel', minTaggedCount: 2 },
{ active: true, tag: 'gwp-neofollics-sets', giftVariantId: '58227588825462', giftHandle: 'neofollics-hair-wrap-towel', minTaggedCount: 1 },
{ active: true, tag: 'gwp-fibresealer', giftVariantId: '58348251021686', giftHandle: 'schwarzkopf-fibre-clinix-fibre-sealer', minTaggedCount: 2 },
{ active: true, tag: 'gwp-fibresealer-sets', giftVariantId: '58348251021686', giftHandle: 'schwarzkopf-fibre-clinix-fibre-sealer', minTaggedCount: 1 },
{ active: true, tag: 'gwp-metamorphose', giftVariantId: '58135633396086', giftHandle: 'metamorphose-argan-nourishing-shampoo-1', minTaggedCount: 2 },
{ active: true, tag: 'gwp-metamorphose-sets', giftVariantId: '58135633396086', giftHandle: 'metamorphose-argan-nourishing-shampoo-1', minTaggedCount: 1 },
{ active: false, tag: 'gwp-olaplexno3', giftVariantId: '58504677032310', giftHandle: 'olaplex-no-3-hair-perfector-20ml', minTaggedCount: 2 },
{ active: false, tag: 'gwp-olaplexno3-sets', giftVariantId: '58504677032310', giftHandle: 'olaplex-no-3-hair-perfector-20ml', minTaggedCount: 1 },
{ active: true, tag: 'gwp-mediceuticalsdri', giftVariantId: '56327714046326', giftHandle: 'mediceuticals-bao-med-hair-mask', minTaggedCount: 1 },

// Wella EIMI Dry Me: losse producten tellen 1, sets van 2/3/4 tellen 2/3/4 (zie GWP_TAG_WEIGHTS)
{ active: true, tag: 'gwp-welladryme-weight', giftVariantId: '56328014987638', giftHandle: 'eimi-dry-me-droogshampoo', minTaggedCount: 4 },

// Wella-tiers op basis van gecombineerd gewicht (losse producten + sets tellen nu samen op)
{ active: false, tag: 'gwp-wella-weight', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo', minTaggedCount: 2 },
{ active: false, tag: 'gwp-wella-weight', giftVariantId: '56328013087094', giftHandle: 'wella-oil-reflections-luminous-smoothening-oil', minTaggedCount: 3 },
{ active: false, tag: 'gwp-wella-weight', giftVariantId: '56755987939702', giftHandle: 'giftvoucher-10', minTaggedCount: 4 },
];

// Gewicht per Wella-tag: losse producten en sets tellen nu op tot één totaal
var WELLA_TAG_WEIGHTS = {
  'gwp-wella-multibuy': 1,
  'gwp-wella-set-2pack': 2,
  'gwp-wella-set-3pack': 3,
  'gwp-wella-set-4pack': 4,
};

// Generieke gewogen tellers: campagne-tag => { product-tag: gewicht }
// De campagne-tag (bijv. 'gwp-welladryme-weight') wordt niet op producten gezet,
// alleen de product-tags hieronder.
var GWP_TAG_WEIGHTS = {
  'gwp-welladryme-weight': {
    'gwp-welladryme': 1,
    'gwp-welladryme-set-2pack': 2,
    'gwp-welladryme-set-3pack': 3,
    'gwp-welladryme-set-4pack': 4,
  },
};

// Alleen voor de voorraad-check van de productpagina-badges (los van cart-telling)
var GWP_BADGE_STOCK_CHECKS = [
  { tag: 'gwp-wella-multibuy', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { tag: 'gwp-wella-set-2pack', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { tag: 'gwp-wella-set-3pack', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  { tag: 'gwp-wella-set-4pack', giftVariantId: '56328020296054', giftHandle: 'wella-fusion-shampoo' },
  // Dry Me: alle product-tags delen dezelfde overlay-klasse (.overlay-gwp-welladryme)
  { tag: 'gwp-welladryme', giftVariantId: '56328014987638', giftHandle: 'eimi-dry-me-droogshampoo' },
];

// Zet op true om de Wella 2/3/4-kortingsactie weer te activeren
var WELLA_TIERS_ACTIVE = false;

// Kortingscodes die de Wella-cadeaus daadwerkelijk op €0 zetten.
// Moeten al bestaan in Shopify Admin — het script kiest alleen welke van toepassing is.
var WELLA_TIER_DISCOUNT_CODES = {
  0: 'GWP-WELLA-CLEAR',   // geen tier behaald: eerdere code neutraliseren
  2: 'GWP-WELLA-TIER1',   // Fusion gratis
  3: 'GWP-WELLA-TIER2',   // Fusion + Oil gratis
  4: 'GWP-WELLA-TIER3',   // Fusion + Oil + Voucher gratis
};

// Wella EIMI Dry Me: kortingscode die de gift op €0 zet.
// GWP-DRYME moet in Shopify Admin bestaan (100% op alleen variant 56328014987638).
// Geen gift in de winkelmand? Dan wordt de bestaande neutrale code (GWP-WELLA-CLEAR) toegepast.
var DRYME_DISCOUNT_ACTIVE = true;
var DRYME_VARIANT_ID = '56328014987638';
var DRYME_DISCOUNT_CODE = 'GWP-DRYME';
var DRYME_CLEAR_CODE = 'GWP-WELLA-CLEAR';

// ============================================
// Logica — niet aanpassen
// ============================================

var gwpRunning = false;
var gwpFetching = false;

function gwpGetCart() {
  return fetch('/cart.js').then(function(r) { return r.json(); });
}
function gwpAddToCartBatch(variantIds) {
  if (!variantIds.length) return Promise.resolve();
  gwpFetching = true;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: variantIds.map(function(id) { return { id: id, quantity: 1, properties: { _gwp: 'true' } }; })
    }),
  }).finally(function() { gwpFetching = false; });
}

function gwpRemoveFromCartBatch(variantIds) {
  if (!variantIds.length) return Promise.resolve();
  gwpFetching = true;
  var updates = {};
  variantIds.forEach(function(id) { updates[id] = 0; });
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates }),
  }).finally(function() { gwpFetching = false; });
}

async function gwpIsGiftAvailable(handle, variantId) {
  try {
    var res = await fetch('/products/' + handle + '.js');
    var product = await res.json();
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) {
        return product.variants[i].available;
      }
    }
    return false;
  } catch(e) { return false; }
}

var productTagCache = {};
async function gwpGetProductTags(handle) {
  if (productTagCache[handle]) return productTagCache[handle];
  try {
    var res = await fetch('/products/' + handle + '.js');
    var product = await res.json();
    productTagCache[handle] = product.tags || [];
    return productTagCache[handle];
  } catch(e) { return []; }
}

function gwpWellaTierCodeForWeight(weight) {
  if (weight >= 4) return WELLA_TIER_DISCOUNT_CODES[4];
  if (weight === 3) return WELLA_TIER_DISCOUNT_CODES[3];
  if (weight === 2) return WELLA_TIER_DISCOUNT_CODES[2];
  return WELLA_TIER_DISCOUNT_CODES[0];
}

function gwpSetCartAttribute(key, value) {
  var attrs = {};
  attrs[key] = value;
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attrs }),
  });
}

function gwpApplyDiscountCode(code) {
  var redirectTo = window.location.pathname + window.location.search;
  window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectTo);
}

async function updateGWP() {
  if (gwpRunning) return;
  gwpRunning = true;
  productTagCache = {};

  try {
    var cart = await gwpGetCart();

    var giftMap = {};
    for (var i = 0; i < GWP_CAMPAIGNS.length; i++) {
      var camp = GWP_CAMPAIGNS[i];
      if (!camp.active) continue;
      var vid = String(camp.giftVariantId);
      if (!giftMap[vid]) giftMap[vid] = { campaigns: [], giftHandle: camp.giftHandle };
      giftMap[vid].campaigns.push(camp);
    }

    var uniqueTags = {};
    for (var gi = 0; gi < GWP_CAMPAIGNS.length; gi++) {
      if (GWP_CAMPAIGNS[gi].active) uniqueTags[GWP_CAMPAIGNS[gi].tag] = true;
    }

    var relevantItems = cart.items.filter(function(item) {
      return !(item.properties && item.properties._gwp === 'true');
    });

    // Tags van alle unieke handles PARALLEL ophalen (was: na elkaar)
    var uniqueHandles = {};
    relevantItems.forEach(function(item) { uniqueHandles[item.handle] = true; });
    await Promise.all(Object.keys(uniqueHandles).map(gwpGetProductTags));

    var tagCounts = {};
    var wellaWeight = 0;
    var weightedCounts = {};
    for (var j = 0; j < relevantItems.length; j++) {
      var item = relevantItems[j];
      var tags = productTagCache[item.handle] || [];
      for (var tag in uniqueTags) {
        if (!tagCounts[tag]) tagCounts[tag] = 0;
        if (tags.includes(tag)) tagCounts[tag] += item.quantity;
      }
      // Gecombineerd Wella-gewicht: losse producten + sets tellen nu samen op
      for (var wtag in WELLA_TAG_WEIGHTS) {
        if (tags.includes(wtag)) {
          wellaWeight += WELLA_TAG_WEIGHTS[wtag] * item.quantity;
        }
      }
      // Generieke gewogen tellers (bijv. Dry Me: los = 1, set-2pack = 2, ...)
      for (var vtag in GWP_TAG_WEIGHTS) {
        if (!uniqueTags[vtag]) continue;
        for (var ptag in GWP_TAG_WEIGHTS[vtag]) {
          if (tags.includes(ptag)) {
            weightedCounts[vtag] = (weightedCounts[vtag] || 0) + GWP_TAG_WEIGHTS[vtag][ptag] * item.quantity;
          }
        }
      }
    }
    tagCounts['gwp-wella-weight'] = wellaWeight;
    for (var wk in weightedCounts) tagCounts[wk] = weightedCounts[wk];

    // Voorraad van alle gifts PARALLEL checken (was: na elkaar)
    var giftVariantIds = Object.keys(giftMap);
    var availabilityList = await Promise.all(giftVariantIds.map(function(vid) {
      return gwpIsGiftAvailable(giftMap[vid].giftHandle, vid);
    }));
    var availabilityMap = {};
    giftVariantIds.forEach(function(vid, idx) { availabilityMap[vid] = availabilityList[idx]; });

    var toAdd = [];
    var toRemove = [];
    var giftWanted = {};

    for (var g = 0; g < giftVariantIds.length; g++) {
      var giftVariantId = giftVariantIds[g];
      var campaigns = giftMap[giftVariantId].campaigns;

      var giftInCart = null;
      for (var k = 0; k < cart.items.length; k++) {
        var cartItem = cart.items[k];
        if (String(cartItem.variant_id) === giftVariantId &&
            cartItem.properties && cartItem.properties._gwp === 'true') {
          giftInCart = cartItem;
        }
      }
      var currentGiftQty = giftInCart ? giftInCart.quantity : 0;

      var anyTriggered = false;
      for (var c2 = 0; c2 < campaigns.length; c2++) {
        var minRequired = campaigns[c2].minTaggedCount || 1;
        if ((tagCounts[campaigns[c2].tag] || 0) >= minRequired) {
          anyTriggered = true;
          break;
        }
      }

      var giftAvailable = availabilityMap[giftVariantId];
      giftWanted[giftVariantId] = !!(anyTriggered && giftAvailable);

      if (!giftAvailable) {
        if (currentGiftQty > 0) toRemove.push(giftVariantId);
        continue;
      }

      if (anyTriggered && currentGiftQty === 0) {
        toAdd.push(giftVariantId);
      } else if (anyTriggered && currentGiftQty > 1) {
        toRemove.push(giftVariantId);
        toAdd.push(giftVariantId);
      } else if (!anyTriggered && currentGiftQty > 0) {
        toRemove.push(giftVariantId);
      }
    }

    var needsReload = toAdd.length > 0 || toRemove.length > 0;

    // Eén batch-verwijdering, dan één batch-toevoeging (i.p.v. losse calls per gift)
    if (toRemove.length) await gwpRemoveFromCartBatch(toRemove);
    if (toAdd.length) await gwpAddToCartBatch(toAdd);

    // Wella-kortingscode: zorgt dat de juiste tier ook echt op €0 komt
    if (WELLA_TIERS_ACTIVE) {
      var desiredWellaCode = gwpWellaTierCodeForWeight(wellaWeight);
      var currentWellaCode = (cart.attributes && cart.attributes._gwp_wella_tier) || WELLA_TIER_DISCOUNT_CODES[0];

      if (desiredWellaCode !== currentWellaCode) {
        await gwpSetCartAttribute('_gwp_wella_tier', desiredWellaCode);
        gwpApplyDiscountCode(desiredWellaCode); // navigeert weg, dus geen reload nodig hierna
        return;
      }
    }

    // Dry Me-kortingscode: gift op €0 zolang de gift verdiend is, anders neutraliseren.
    // Draait alleen als de Wella-tiers uit staan, anders strijden twee codes om hetzelfde slot.
    if (DRYME_DISCOUNT_ACTIVE && !WELLA_TIERS_ACTIVE) {
      var desiredDryMeCode = giftWanted[DRYME_VARIANT_ID] ? DRYME_DISCOUNT_CODE : DRYME_CLEAR_CODE;
      var currentDryMeCode = (cart.attributes && cart.attributes._gwp_dryme_code) || DRYME_CLEAR_CODE;

      if (desiredDryMeCode !== currentDryMeCode) {
        await gwpSetCartAttribute('_gwp_dryme_code', desiredDryMeCode);
        gwpApplyDiscountCode(desiredDryMeCode); // navigeert weg, dus geen reload nodig hierna
        return;
      }
    }

    if (needsReload) {
      location.reload();
      return;
    }

  } catch(e) { console.error('GWP error:', e); }

  gwpRunning = false;
}

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(updateGWP, 300); // was 800ms
});

document.addEventListener('cart:updated', function() { gwpRunning = false; updateGWP(); });
document.addEventListener('cart:refresh', function() { gwpRunning = false; updateGWP(); });

var _fetch = window.fetch;
window.fetch = function() {
  var args = arguments;
  return _fetch.apply(this, args).then(function(res) {
    if (gwpFetching) return res;
    var url = typeof args[0] === 'string' ? args[0] : '';
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
      setTimeout(function() { gwpRunning = false; updateGWP(); }, 100); // was 300ms
    }
    return res;
  });
};

// Productpagina badge voorraad check
(function() {
  var checks = GWP_CAMPAIGNS.concat(GWP_BADGE_STOCK_CHECKS);
  checks.forEach(function(campaign) {
    if (campaign.active === false || !campaign.giftHandle) return;
    var selector = '.overlay-gwp-' + campaign.tag.replace('gwp-', '');
    var el = document.querySelector(selector);
    if (!el) return;
    fetch('/products/' + campaign.giftHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var available = p.variants.some(function(v) {
          return String(v.id) === String(campaign.giftVariantId) && v.available;
        });
        if (!available) el.style.display = 'none';
      });
  });
})();